import { render, staticRenderFns } from "./FreightResult.vue?vue&type=template&id=98c78df2&scoped=true&"
import script from "./FreightResult.vue?vue&type=script&lang=js&"
export * from "./FreightResult.vue?vue&type=script&lang=js&"
import style0 from "./FreightResult.vue?vue&type=style&index=0&id=98c78df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c78df2",
  null
  
)

export default component.exports